import React from 'react';
import { Helmet } from 'react-helmet-async';

const SubmitToolPage = () => {
  return (
    <div className="min-h-screen pt-24 page-bg-shell page-bg-devices" data-testid="submit-tool-page">
      <Helmet>
        <title>Submit Tool (Coming Soon) | Wowrolla</title>
        <meta name="description" content="Submit Tool is coming soon. Wowrolla is based in Ottawa, Ontario, Canada." />
      </Helmet>

      <section className="container mx-auto px-6 pb-16 max-w-3xl text-center">
        <h1 className="text-4xl font-black mb-4" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
          Submit Tool
        </h1>
        <p className="text-lg mb-2" style={{ color: 'var(--text-secondary)' }}>
          Coming soon.
        </p>
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
          We are preparing a structured intake workflow for vendors and maintainers.
        </p>
      </section>
    </div>
  );
};

export default SubmitToolPage;

